/* script */
//
//
//
//
//
//
//
//
//
//
//

// Components
import Wizard from 'shared/ui/components/Wizard.vue';
import General from 'ui/components/wizards/create-webinar-template/General.vue';
import Design from 'ui/components/wizards/create-webinar-template/Design.vue';
import Registration from 'ui/components/wizards/create-webinar-template/Registration.vue';
import Integrations from 'ui/components/wizards/create-webinar-template/Integrations.vue';

// Model
import WebinarTemplate from 'libs/models/webinar/webinar-template';

// Mixins
import templateFetcher from 'ui/mixins/webinars/templates-fetcher';

const __vue_script__ = {
    name: 'CreateWebinarTemplate',

    components: {
        Wizard,
        Integrations
    },

    mixins: [templateFetcher],

    data() {
        const user = this.$services.user.getCurrentUser();
        const orgId = this.getOrgId(user);
        return {
            progress: 0,
            steps: [
                {
                    title: 'wizards.create_webinar_template.step_1_title',
                    component: General
                },
                {
                    title: 'wizards.create_webinar_template.step_2_title',
                    component: Design
                },
                {
                    title: 'wizards.create_webinar_template.step_3_title',
                    component: Registration,
                    nextLabel: 'wizards.create_webinar_template.action'
                }
                // TODO: uncomment when integrations are implemented
                // {
                //     title: 'wizards.create_webinar_template.step_4_title',
                //     component: Integrations,
                //     nextLabel: 'wizards.create_webinar_template.action'
                // }
            ],
            templateModel: new WebinarTemplate({ brand_color: '#3185FC', bs_owner_id: orgId }),
            wizardCompleted: false,
            orgId
        };
    },

    computed: {
        /**
         * @returns {Boolean} whether the wizard is complete or not
         */
        showWizard() {
            return !this.wizardCompleted;
        }
    },

    methods: {
        async submitForm(data) {
            let type = 'success';
            let text = this.$i18n.t('wizards.create_webinar_template.template_created')
                .toString();

            await this.$services.webinar.createTemplate(data, this.orgId)
                .catch(() => {
                    type = 'error';
                    text = this.$i18n.t('wizards.create_webinar_template.template_creation_failed').toString();
                })
                .finally(() => {
                    this.$notify({
                        group: 'flashes',
                        type,
                        text
                    });
                });

            this.wizardCompleted = true;
            this.$services.webinar.emit('webinarTemplateCreated');
            this.close();
        },

        close() {
            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWizard)?_c('wizard',{staticClass:"create-webinar-template",attrs:{"initial-data":_vm.templateModel,"steps":_vm.steps,"target":"_blank"},on:{"wizard:completed":_vm.submitForm}},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.close()}}}),_c('h1',[_vm._v(_vm._s(_vm.$t('wizards.create_webinar_template.main_title')))])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CreateWebinarTemplate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__